class ProductPackage extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()
  }

  setupListeners () {
    super.setupListeners()

    this.updateAriaHidden = this.updateAriaHidden.bind(this)
    this.scrollTo = this.scrollTo.bind(this)

    this.els?.trigger?.elements.forEach((triggerEl) => {
      triggerEl.addEventListener('click', this.updateAriaHidden)
    })

    this.els?.button?.elements.forEach((buttonEl) => {
      buttonEl.addEventListener('click', this.scrollTo)
    })
  }

  updateAriaHidden (event) {
    const triggerEl = event.target.closest(this.els?.trigger?.selector)

    this.els?.item?.elements.forEach((itemEl) => {
      itemEl.setAttribute(
        'aria-hidden',
        itemEl.getAttribute(`data-package-${triggerEl.dataset.package}`) !==
          'true',
      )
    })

    this.els?.trigger?.elements.forEach((el) => {
      el.setAttribute('aria-pressed', el === triggerEl)
    })

    this.els.title.element.innerText = triggerEl.dataset.productPackageTitle
  }

  scrollTo () {
    this.externalEls?.form?.element.scrollIntoView({
      behavior: 'smooth',
      block: 'center',
    })
  }
}

if (!customElements.get('product-package')) {
  customElements.define('product-package', ProductPackage)
}
